import './Header.scss';
import Logo  from '../../images/logo.png';

import { usePageMetadata } from '../../context/PageMetadataContext';
import { useAuth } from '../../context/AuthContext';
import { Link } from 'react-router-dom';
import { AppButton } from "../ui";




const Header = ({ children, dashboard }) => {
  const { title, showTitleInHeader } = usePageMetadata();

  const { organizationName, isAuthenticated, subscriptionStatus } = useAuth();
  const isSubscribed =
    subscriptionStatus === "subscribed" || subscriptionStatus === "perpetual";
 

  return (
    <div className={`header ${dashboard ? "header--dashboard" : ""}`}>
      <div className="header-left">
 
        <Link to="/">
          <img src ={Logo} alt="10k Science" />
        </Link>
        
      </div>

      {showTitleInHeader && (
        <div className="header-center">
          <h1>{title}</h1>
        </div>
      )}
      <div className="header-right">
        {children}
        {dashboard && isAuthenticated && !isSubscribed && (
          <AppButton
            className="header-billing-button"
            component={Link}
            kind="primary"
            to="/upgrade"
          >
            Upgrade
          </AppButton>
        )}
        {dashboard && organizationName && <h2>{organizationName}</h2>}
      </div>
    </div>
  );
}

export default Header;
